import Vue from 'vue'
import { Component, Mixins } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import * as accountTypes from '@account/store/types'

@Component({
    computed: mapGetters({
        user: accountTypes.CURRENT
    })
})
export default class MyInfoWebpart extends Vue {
    user!: account.TCurrent;

    // computed
    get isKorean(): boolean {
        return this.user.userConfig.language.indexOf("ko") > -1;
    }

    get isJapanese(): boolean {
        return this.user.userConfig.language.indexOf("ja") > -1;
    }

    getPhotoUrl(){
        if(this.user.user.photoPath && this.user.user.photoPath != ""){
            return this.user.user.photoPath
        }else{
            return "/cm/gres/faux/images/ghost.png"
        }
    }
}
